export default __webpack_public_path__ + "static/media/torri2.1345f40a.png";